import development from './development.json';
import production from './production.json';
import stage from './stage.json';

interface RuntimeEnvironment {
  APP_API_HOST: string;
  APP_API_PORT: string;
  APP_FALLBACK_URL: string;
}

const AVAILABLE_ENVIRONMENTS: {
  [key: string]: RuntimeEnvironment
} = {
  development,
  production,
  stage
};

export default AVAILABLE_ENVIRONMENTS;
